<template>
    <div class="department-contacts" v-if="data && data.length">
        <z-accordion initial="first">
            <z-accordion-item
                v-for="tab in data"
                :key="tab.code"
                :id="tab.code"
            >
                <template v-slot:header>
                    <span v-html="tab.name"></span>
                </template>
                <template v-slot:body>
                    <div class="department-contacts__head">
                        <div class="row">
                            <div class="col-default-12">
                                <div class="card">
                                    <span
                                        class="card__caption u-bottom-margin--no-important"
                                        v-html="tab.name"
                                    ></span>
                                    <div class="card__body">
                                        <div class="card__row">
                                            <div class="u-right-margin--one" v-if="tab.phone">
                                                <span class="card__name">{{text.phone}}:</span>
                                                <z-link :href="`tel:${tab.phone}`" v-html="tab.phone"></z-link>
                                            </div>
                                            <div class="u-right-margin--one" v-if="tab.fax">
                                                <span class="card__name">{{text.fax}}:</span>
                                                <z-link :href="`fax:${tab.fax}`" v-html="tab.fax"></z-link>
                                            </div>
                                            <div class="u-right-margin--one" v-if="tab.email">
                                                <span class="card__name">{{text.email}}:</span>
                                                <z-link :href="`mailto:${tab.email}`" v-html="tab.email"></z-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-default-6 col-v-tablet-12"
                                v-for="(item, index) in getLeadManagers(tab.items)"
                                :key="index"
                            >
                                <div class="person person--contact">
                                    <div class="person__info">
                                        <div class="person__image person__image--sm">
                                            <img :src="item.image" :alt="item.name" />
                                        </div>
                                        <div>
                                            <span class="person__name" v-html="item.name"></span>
                                            <span class="person__post" v-html="item.position"></span>
                                        </div>
                                    </div>
                                    <div class="person__contacts">
                                        <div class="person__contacts-row" v-if="item.phone">
                                            <span class="person__contacts-key">{{text.phone}}:</span>
                                            <span v-html="item.phone"></span>
                                        </div>
                                        <div class="person__contacts-row" v-if="item.mobile">
                                            <span class="person__contacts-key">{{text.mobile}}:</span>
                                            <z-link :href="`tel:${item.mobile}`">{{text.call}}</z-link>
                                        </div>
                                        <div class="person__contacts-row" v-if="item.email">
                                            <span class="person__contacts-key">{{text.email}}:</span>
                                            <z-link :href="`mailto:${item.email}`">{{text.write}}</z-link>
                                        </div>
                                        <div class="person__contacts-row" v-if="item.sales">
                                            <span class="person__contacts-key">{{text.sales}}:</span>
                                            <span v-html="item.sales"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-default-6 col-v-tablet-12">
                                <z-list v-if="getDepartment(tab.items).length">
                                    <z-list-item
                                        v-for="item in getDepartmentList(tab.items)"
                                        :key="item.code"
                                    >
                                        <z-link :href="`#${item.code}`" v-html="item.name"></z-link>
                                    </z-list-item>
                                </z-list>
                            </div>
                        </div>
                    </div>
                    <div class="department-contacts__body">
                        <div
                            v-for="(item, index) in getDepartmentList(tab.items)"
                            :key="index"
                            :id="item.code"
                            class="department-contacts__section"
                        >
                            <div class="row">
                                <div class="col-default-12" v-if="item.code">
                                    <div class="card">
                                        <span
                                            class="card__caption u-bottom-margin--no-important"
                                            v-html="item.name"
                                        ></span>
                                    </div>
                                </div>
                                <div
                                    class="col-default-6 col-v-tablet-12"
                                    v-for="(item, index) in getDepartmentItems(item.code, tab.items)"
                                    :key="index"
                                >
                                    <div class="person person--contact">
                                        <div class="person__info">
                                            <div class="person__image person__image--sm">
                                                <img :src="item.image" :alt="item.name" />
                                            </div>
                                            <div>
                                                <span class="person__name" v-html="item.name"></span>
                                                <span class="person__post" v-html="item.position"></span>
                                            </div>
                                        </div>
                                        <div class="person__contacts">
                                            <div class="person__contacts-row" v-if="item.phone">
                                                <span class="person__contacts-key">{{text.phone}}:</span>
                                                <span v-html="item.phone"></span>
                                            </div>
                                            <div class="person__contacts-row" v-if="item.mobile">
                                                <span class="person__contacts-key">{{text.mobile}}:</span>
                                                <z-link :href="`tel:${item.mobile}`">{{text.call}}</z-link>
                                            </div>
                                            <div class="person__contacts-row" v-if="item.email">
                                                <span class="person__contacts-key">{{text.email}}:</span>
                                                <z-link :href="`mailto:${item.email}`">{{text.write}}</z-link>
                                            </div>
                                            <div class="person__contacts-row" v-if="item.sales">
                                                <span class="person__contacts-key">{{text.sales}}:</span>
                                                <span
                                                    v-for="(country, index) in item.sales"
                                                    :key="index"
                                                >{{country}}{{index !== item.sales.length - 1 ? ', ' : ''}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </z-accordion-item>
        </z-accordion>
    </div>
</template>

<script>
export default {
    name: 'department-contacts',
    data () {
        return {
            text: {
                phone: this.$root.lang === 'ru' ? 'Телефон' : 'Phone',
                mobile: this.$root.lang === 'ru' ? 'Мобильный телефон' : 'Mobile',
                fax: this.$root.lang === 'ru' ? 'Факс' : 'Fax',
                email: this.$root.lang === 'ru' ? 'E-mail' : 'E-mail',
                sales: this.$root.lang === 'ru' ? 'География продаж' : 'Geography Sales',
                write: this.$root.lang === 'ru' ? 'Написать' : 'Write',
                call: this.$root.lang === 'ru' ? 'Позвонить' : 'Call'
            }
        }
    },
    computed: {
        data () {
            return this.$root.app.components['department-contacts'] ? this.$root.app.components['department-contacts'] : []
        }
    },
    methods: {
        getLeadManagers (items, lead = true) {
            return items.filter(item => lead ? item.lead : !item.lead)
        },
        getDepartment (items) {
            return items.filter(item => item.department)
        },
        getDepartmentList (items) {
            const departments = this.getDepartment(items).map(item => item.department)

            if (departments.length) {
                const uniqueDepartments = Array.from(new Set(departments.map(JSON.stringify))).map(JSON.parse)
                return uniqueDepartments
            } else {
                return this.getLeadManagers(items, false)
            }
        },
        getDepartmentItems (code, items) {
            if (code) {
                return this.getDepartment(items).filter(item => item.department.code === code)
            } else {
                return this.getLeadManagers(items, false)
            }
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
